import styled from 'styled-components'
import { Caption1, StyledButton } from 'components/common/typography'
import { sizeMobile } from 'components/globalStyles'

export const MainContainer = styled.dialog`
  display: block;
  position: absolute;
  left: ${props => props.$offset}px;
  bottom: -4px;
  padding: 32px;
  z-index: 100;
  background: white;
  pointer-events: all;
  border: none;
  transform: translateY(100%);
  filter: drop-shadow(0 1px 16px rgba(17, 17, 17, 0.1));

  @media (max-width: ${sizeMobile}) {
    position: fixed;
    width: 100vw;
    height: calc(100vh - 64px);
    top: 64px;
    left: 0;
    bottom: auto;
    transform: none;
    filter: none;
    background: white;
    padding-top: 48px;
    display: flex;
    flex-direction: column;
    align-items: center;

    & label {
      font-size: 1.8rem;
    }
  }
`

export const AdultChildGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, auto);
  justify-items: start;
  align-items: center;
  column-gap: 8px;
  row-gap: 16px;
`

export const ChildCaption = styled(Caption1)`
  color: var(--gray1);
  margin-top: -12px;
  display: flex;
  gap: 6px;
  text-align: left;
  align-items: center;
`

export const Divider = styled.hr`
  width: 100%;
  height: 1px;
  border: none;
  background-color: var(--gray4);
  margin: 16px 0;
`

export const DogRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  width: 100%;
  font-family: Proxima;
`

export const FeeRow = styled.div`
  display: flex;
  gap: 6px;
  align-items: start;
`

export const FeeCaption = styled(Caption1)`
  color: var(--gray1);
  text-align: left;
  transform: translateY(1px);
`

export const ApplyButton = styled(StyledButton)`
  margin-top: 24px;
`